import React, { useState, useRef, useEffect } from "react";
import "./information&promo.css";
import NavComplete from "./Component/Navbar1";
import Footer from "./Component/footer";
import promo_img from "./Assets/Promo-doodle.png";
import { Container, Row, Col, Card } from "react-bootstrap";
import Promo1 from "./Promo/Promo1";
import Promo2 from "./Promo/Promo2";
import Promo3 from "./Promo/Promo3";
import Promo4 from "./Promo/Promo4";
import Promo5 from "./Promo/Promo5";
import Promo6 from "./Promo/Promo6";
import Promo7 from "./Promo/Promo7";
import Promo8 from "./Promo/Promo8";
import Promo9 from "./Promo/Promo9";

const Promopage = () => {
  const [selectedPromo, setSelectedPromo] = useState(null);
  const [promo_card, setPromoCard] = useState([]);
  const promo1Ref = useRef(null);

  const scrollToPromo = (ref) => {
    const navbarHeight = 88; // Replace with the actual height of your navigation bar
    const rect = ref.current.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const targetOffset = rect.top + scrollTop - navbarHeight;

    window.scrollTo({
      top: targetOffset,
      behavior: "smooth",
    });
  };
  const togglePromo = (Urutan) => {
    setSelectedPromo(Urutan === selectedPromo ? null : Urutan);
    setTimeout(() => {
      if (selectedPromo !== Urutan) {
        scrollToPromo(promo1Ref);
      }
    }, 600);
  };

  useEffect(() => {
    const cards = [
      {
        img: "https://i.ibb.co.com/x7ws8tf/sept-berkah.jpg",
      },
      {
        img: "https://i.ibb.co.com/QXP3ZcH/paket-bulanan.jpg",
      },
      {
        img: "https://i.ibb.co.com/pXDyx4g/Premium-detailing.webp",
      },
      {
        img: "https://i.ibb.co.com/7CLZ6W0/Gold-detailing.webp",
      },
      {
        img: "https://i.ibb.co.com/txG4thN/Silver-detailing.webp",
      },
      {
        img: "https://i.ibb.co.com/925hqVs/Premium-coating.webp",
      },
      {
        img: "https://i.ibb.co.com/ZL8HQS4/Ultimate-coating.webp",
      },
      {
        img: "https://i.ibb.co.com/vhRS8NB/Ultimate-detailing.webp",
      },
      {
        img: "https://i.ibb.co.com/cYqPKbt/Gold-coating.webp",
      },
    ];
    setPromoCard(cards);
  }, []);
  return (
    <>
      <NavComplete />
      <section className="welcome-section-i">
        <img src={promo_img} alt="car" className="welcome-car-image-i" />
        <Container className="container-1-i">
          <div className="welcome-content-i ">
            <h1 className="roleway">
              {localStorage.getItem("bahasa") === "ing" ? "Promo" : "Promo"}
            </h1>
          </div>
        </Container>
        <Container
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Row className="promo-card-wraper">
            {promo_card.map((item, index) => {
              return (
                <Col md={6} style={{ padding: "0px 0px" }} key={index}>
                  <Card
                    className="promo-card "
                    onClick={() => togglePromo(index)}
                  >
                    <Card.Img
                      variant="top"
                      src={item.img} // Replace with your image URL
                      className="card-shadow"
                    />
                    <Card.Body></Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
          <Row ref={promo1Ref} style={{ maxWidth: "100vw", margin: "0px 0px" }}>
            {selectedPromo === 0 ? (
              <Promo1 />
            ) : selectedPromo === 1 ? (
              <Promo2 />
            ) : selectedPromo === 2 ? (
              <Promo3 />
            ) : selectedPromo === 3 ? (
              <Promo4 />
            ) : selectedPromo === 4 ? (
              <Promo5 />
            ) : selectedPromo === 5 ? (
              <Promo6 />
            ) : selectedPromo === 6 ? (
              <Promo7 />
            ) : selectedPromo === 7 ? (
              <Promo8 />
            ) : selectedPromo === 8 ? (
              <Promo9 />
            ) : null}
          </Row>
        </Container>
        <Footer />
      </section>
    </>
  );
};

export default Promopage;
